import React, { FC } from 'react';
import { FiltersNameEnum, SelectOption, useFiltersLabel, FilterDrawerType } from '@blocs.filter';
import { RangeSelector } from '../../../shared/components';
import { RangeList, RangeItem } from '../ClothingSizesStyles';

type Props = {
  showInImperial: boolean;
  type: FilterDrawerType;
  optionsList: { [key: string]: SelectOption[] };
};

const ClothingSizesGeneral: FC<Props> = ({ showInImperial, type, optionsList }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);
  const { waistsOptions, inseamsOptions, glovesOptions, hatsOptions } = optionsList;

  return (
    <RangeList>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.waist}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.waist]}
          options={waistsOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.inseam}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.inseam]}
          options={inseamsOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.glove}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.glove]}
          options={glovesOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.hat}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.hat]}
          options={hatsOptions}
        />
      </RangeItem>
    </RangeList>
  );
};

export default ClothingSizesGeneral;
